import styled from 'styled-components'
import border from '../../tokens/border'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import { defaultTheme } from '../../theming/data/defaultTheme'
import layout from '../../tokens/layout'
import typography from '../../tokens/typography'
import { composeTheme } from '../../utils/compose-theme'

export const Area = styled.textarea.attrs((props) => composeTheme(props))`
  border: ${border.width.widthThin} solid ${colors.neutralColorLowLight};
  border-radius: ${border.radius.radiusSm};
  padding: ${layout.padding.spacingInsetXs} ${layout.padding.spacingInsetXs}
    ${layout.padding.spacingInsetXs} ${layout.padding.spacingInsetXs};
  resize: none;
  line-height: ${typography.fontHeight.lineHeightLg};
  white-space: pre-line;
  color: ${colors.neutralColorLowPure};
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-weight: ${typography.fontWeight.fontWeightRegular};
  font-style: normal;
  scrollbar-color: ${colors.neutralColorLowLight} transparent;
  scrollbar-width: thin;

  &:focus {
    border: ${border.width.widthThin} solid
      ${(props) => props.theme.brandColors.primaryPure};
    outline: none;
  }

  &::-webkit-scrollbar {
    z-index: 999;
    width: 2rem;
    height: 2rem;
  }

  &::-webkit-scrollbar-track {
    background-color: ${colors.neutralColorHighLight};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.neutralColorLowLight};
    border: ${border.width.widthHeavy} solid ${colors.neutralColorHighLight};

    &:hover {
      background-color: ${colors.neutralColorLowLight};
    }
  }

  &:disabled {
    color: ${colors.neutralColorLowMedium};
    background-color: ${colors.neutralColorHighLight};
  }

  &.negative {
    border-color: ${colors.feedbackColorNegativePure};
    background-color: ${colors.feedbackColorNegativeLight};
  }
`

Area.defaultProps = defaultTheme

export const Label = styled.label`
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: ${layout.margin.spacingNano};
  line-height: ${typography.fontHeight.lineHeightSm};
  color: ${colors.neutralColorLowPure};
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-weight: ${typography.fontWeight.fontWeightSemiBold};
  font-style: normal;
`
export const Counter = styled.span`
  color: ${colors.neutralColorLowMedium};
  font-weight: ${typography.fontWeight.fontWeightRegular};

  &.error {
    color: ${colors.feedbackColorNegativePure};
  }
`
export const Hint = styled.p.attrs((props) => composeTheme(props))`
  align-items: left;
  color: ${(props) => props.theme.textareaHint.color};
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.textareaHint.fontSize};
  font-style: normal;
  font-weight: ${typography.fontWeight.fontWeightRegular};
  line-height: ${typography.fontHeight.lineHeightLg};
  margin-top: ${(props) => props.theme.textareaHint.marginTop};

  &.negative {
    color: ${(props) => props.theme.hint.negativeColor};
  }
`
export const LabelWrapper = styled.label`
  display: grid;
  grid-template-columns: auto 1fr auto;
  textarea {
    grid-row: 1;
    grid-column: 1/4;
  }
`
export const IconWrapper = styled.div`
  align-items: center;
  top: 2.9rem;
  display: flex;
  height: 4rem;
  grid-row: 1;
  color: inherit;
  grid-column: 3;

  > * {
    padding: ${layout.padding.spacingInsetXs};
  }
`

Hint.defaultProps = defaultTheme
